import Service, { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import Terminal from 'my-phorest/gql/queries/terminal.graphql';
import AnyValidTerminalForBasketPayment from 'my-phorest/gql/queries/any-valid-terminal-for-basket-payment.graphql';
import { queryManager } from 'ember-apollo-client';

export default class TerminalLoaderService extends Service {
  @queryManager apollo;
  @service session;

  @task
  *getTerminal(terminalId) {
    return yield this.apollo.query(
      {
        query: Terminal,
        variables: {
          id: terminalId,
        },
      },
      'terminal'
    );
  }

  @task
  *getAnyValidTerminalForBasketTask() {
    return yield this.apollo.query(
      {
        query: AnyValidTerminalForBasketPayment,
        variables: {
          branchId: this.session.currentBranch.id,
        },
      },
      'anyValidTerminalForBasketPayment'
    );
  }
}
